import { useCallback } from 'react'
import { useMutate } from 'restful-react'
import { useIntl } from '@trileuco/triskel-react-ui/components/i18n'
import { useNotifications } from '@trileuco/triskel-react-ui/components/ui/notifications'
import { useErrorNotification } from 'modules/bookables/notifications'

const useUpdateBookingState = (bookingId, state) => {
  const { mutate, ...rest } = useMutate({
    path: `/bookings/${bookingId}/state`,
    verb: 'PATCH',
    state
  })

  const { notifyError } = useErrorNotification()
  const {
    notify,
    statusTypes: { LOADING, SUCCESS }
  } = useNotifications()

  const { msg } = useIntl({
    scope: 'balaena.api.useUpdateBookingState',
    ignoreGlobalScope: true
  })

  const notifyUpdatedState = useCallback(
    (notification) => {
      notify({
        id: `BOOKING_${bookingId}_UPDATE_STATE`,
        title: msg({ id: notification.status }),
        ...notification
      })
    },
    [msg, notify, bookingId]
  )

  const updateState = useCallback(
    (params) => {
      notifyUpdatedState({ status: LOADING })
      return mutate(params)
        .then((result) => {
          notifyUpdatedState({ status: SUCCESS })
          return result
        })
        .catch((error) => {
          notifyError({
            id: `BOOKING_${bookingId}_UPDATE_STATE`,
            title: msg({ id: 'error' }),
            error
          })
          throw error
        })
    },
    [notifyUpdatedState, LOADING, mutate, SUCCESS, notifyError, msg, bookingId]
  )
  return {
    updateState,
    ...rest
  }
}

export default useUpdateBookingState
